import { useMutation, useQuery } from '@apollo/client'
import { GET_SURGERY_STAFF } from '../graphql/query'
import {
  TAddRemoveSurgeryStaffInput,
  TAddRemoveSurgeryStaffResponse,
  TGetSurgeryStaffResponse,
} from '../RoomView.types'
import { captureWarning } from 'lib/monitoring'
import { useApolloClients } from 'lib/apollo/apolloProvider'
import { ADD_REMOVE_SURGERY_STAFF } from '../graphql/mutation'

export const useGetSurgeryStaff = () => {
  const { iservicesClient: client } = useApolloClients()
  return useQuery<TGetSurgeryStaffResponse>(GET_SURGERY_STAFF, {
    client,
    fetchPolicy: 'no-cache',
    onError: (e: Error) => {
      captureWarning(e)
    },
  })
}

export const useAddRemoveSurgeryStaff = () => {
  const { iservicesClient: client } = useApolloClients()
  return useMutation<
    TAddRemoveSurgeryStaffResponse,
    TAddRemoveSurgeryStaffInput
  >(ADD_REMOVE_SURGERY_STAFF, {
    client,
    onError: (e: Error) => {
      captureWarning(e)
    },
  })
}
